var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeader"},[_c('BaseBtnLastPage',{staticClass:"pageHeader__btn",attrs:{"lastPageBtnIsShow":_vm.lastPageBtnIsShow},on:{"click":function($event){return _vm.$emit('toLastPage')}}}),_c('h3',{staticClass:"pageHeader__title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }